import { NAME_MAX_LENGTH, ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from "@grundbesitz/shared";

/**
 * Turns whatever the player typed or pasted into a room code candidate: upper case, only characters
 * from the code alphabet, at most six of them. A pasted invite link ("https://host/K7Q2ZP") yields its code.
 */
export function normalizeCode(raw: string): string {
  let text = raw.trim();
  if (text.includes("/")) {
    const path = text.split(/[?#]/)[0] ?? "";
    const segments = path.split("/").filter(Boolean);
    text = segments[segments.length - 1] ?? "";
  }
  return [...text.toUpperCase()]
    .filter((c) => ROOM_CODE_ALPHABET.includes(c))
    .join("")
    .slice(0, ROOM_CODE_LENGTH);
}

export function isCompleteCode(code: string): boolean {
  return code.length === ROOM_CODE_LENGTH && [...code].every((c) => ROOM_CODE_ALPHABET.includes(c));
}

/** Name as it is sent to the server: single spaces, no edge whitespace, at most `NAME_MAX_LENGTH` characters. */
export function cleanName(raw: string): string {
  return raw.replace(/\s+/g, " ").trim().slice(0, NAME_MAX_LENGTH).trim();
}
